"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledComboboxAdditional = void 0;
var _ComboboxAdditional = require("./ComboboxAdditional");
// TODO: in v9, move styled() from ComboboxAdditional.jsx to here
var StyledComboboxAdditional = _ComboboxAdditional.ComboboxAdditional;
exports.StyledComboboxAdditional = StyledComboboxAdditional;